import {Category} from "dto/category/category"

export interface RealDevice {
    communicationDevice: CommunicationDevice
    id?: number
    name: string
    serialNumber?: string
    mobile?: PhoneNumber
    address: Address
    etc?: string
    createdAt?: Date
    imageId?: number
    // user: RealDeviceUser
    imageFile?: FileResource
    removeImage?: boolean
    imageFiles?: string[]
    ignoreExternalEmission?: boolean
    battery?: Battery
    category?: Category

    categoryId?: number | undefined
    protector?: Protector
    secondaryProtector?: Protector
    installationDate?: Date
}

type Protector = {
    name?: string,
    mobile?: string,
}

type Battery = {
    level: number
}

export interface FileResource {
    id: number
    name: string
    path: string
    originName?: string
    size?: number
    contentType?: string
    used?: boolean
}

export interface PhoneNumber {
    phoneNumber: string,
}

export interface RealDeviceUser {
    id?: string
    name: string
    mobile?: string
    address: Address
    etc?: string
}

export interface Address {
    address: string
    subAddress?: string
}

export interface CommunicationDevice {
    resetCount?: number;
    eui: string
    lastCommunicationTime?: string
    status?: DeviceStatus
    currentLatLng?: LatLng
    sensorStatus?: SensorStatus
}

export interface SensorStatus {
    abnormal: boolean
    batteryCheck: boolean
    fall: boolean
    moving: boolean
    powerOff: boolean
    reset: boolean
    powerDisconnected: boolean
    batteryCharging: boolean
}

export interface LatLng {
    lat: string
    lng: string
}

export type DeviceStatus = "STAND_BY" | "COMMUNICATION_ERR" | "WORKING" | "EMERGENCY"

export const DeviceStatusValue: { [key: string]: string } = {
    "STAND_BY": "준비중",
    "COMMUNICATION_ERR": "통신오류",
    "WORKING": "운행중",
    "EMERGENCY": "넘어짐감지"
}


export const DeviceStatusTagClassName: { [key: string]: string } = {
    "STAND_BY": "is-light",
    "COMMUNICATION_ERR": "is-warning",
    "WORKING": "is-info",
    "EMERGENCY": "is-danger"
}

export const DeviceStatusImageSrc: { [key: string]: string } = {
    "STAND_BY": "/img/mark-03.png",
    "COMMUNICATION_ERR": "/img/mark-05.png",
    "WORKING": "/img/mark-03.png",
    "EMERGENCY": "/img/mark-05.png"
}

export const DeviceStatusBackgroundClassName: { [key: string]: string } = {
    "STAND_BY": "has-light",
    "COMMUNICATION_ERR": "/img/mark-05.png",
    "WORKING": "/img/mark-03.png",
    "EMERGENCY": "/img/mark-05.png"
}

export function isEmergencyStatus(device: RealDevice) {
    return device.communicationDevice.status === "EMERGENCY"
}

export function isErrorStatus(device: RealDevice) {
    let resetCount = device.communicationDevice.resetCount || 0;
    return (!device.communicationDevice.sensorStatus?.powerOff && device.communicationDevice.status === 'COMMUNICATION_ERR')
        || resetCount > 3
}

export function isNoneOperationStatus(device: RealDevice) {
    return device.communicationDevice.sensorStatus?.powerOff && device.communicationDevice.status === "COMMUNICATION_ERR"
}

export function isPowerDisconnectedStatus(device: RealDevice) {
    return device.communicationDevice.sensorStatus?.powerDisconnected
}